/**
 * @module
 *
 * @import {XUserPopup} from '../../core/service/backend/x-userpopups.js';
 */

import {user} from '../../user/user.js';
import {userPoolFeature} from '../config/feature';
import {guard, IS_HTML} from '@acng/frontend-rubicon';
import {onClick} from '../../layout/service/worker.js';
import {put} from '../../core/service/backend.js';
import {window} from '@acng/frontend-bounty';
import {portal} from '../../core/portal.js';
import {UPGRADE} from '@acng/frontend-stargazer';
import {now} from '@acng/frontend-bounty/timing/now.js';
import {livecamSession} from '../../livecam/context/session.js';
import {inject} from '../../core/service/ng.js';
import {loginTime} from '../../user/auth/login.js';
import {NotificationManager} from '../../user/notification-manager.js';

const {localStorage} = window;

let passwordResetToken = false;
let showDoiHint = false;
let showChangeEmail = false;
let rename = false;
let hadRename = false;
let fskDisclaimerDone = !!localStorage.getItem('fskDisclaimerDone');

/**
 * @param {XUserPopup[]} popupList
 */
const setPopups = (popupList) => {
  for (const {template} of popupList) {
    switch (template) {
      case 'doiHint':
        showDoiHint = true;
        break;
      case 'renameOverlay':
        rename = !hadRename;
        break;
      case 'changeEmail':
        showChangeEmail = true;
        break;
      case 'requestMailDoi':
        showDoiHint = true;
        break;
    }
  }
};

const triggerPopups = () => {
  const onsOverlay = inject('onsOverlay');

  if (user.guest || livecamSession || onsOverlay.count()) {
    return;
  }
  //onsOverlay.create('confirm-device').disableBackdrop().open();

  if (passwordResetToken) {
    onsOverlay
      .create('passwordSetOverlay', {
        email: user.email,
        token: user.password_reset_token,
      })
      .disableBackdrop()
      .disableCloseButtonInToolbar()
      .open();

    passwordResetToken = false;
  } else if (rename) {
    onsOverlay.create('renameOverlay').disableBackdrop().disableCloseButtonInToolbar().open();

    rename = false;
    hadRename = true;
  } else if (portal.fsk.disclaimer && user.fsk < 18 && !fskDisclaimerDone) {
    fskDisclaimerDone = true;

    userPoolFeature.popup(null, 'fsk-disclaimer', (close) => ({
      /**
       * @type {import('@acng/frontend-stargazer').Controller}
       */
      click: {
        [UPGRADE](node) {
          ASSERT: guard(node, IS_HTML);
          onClick(node, async () => {
            localStorage.setItem('fskDisclaimerDone', 'true');
            close();
            await put('user/fsk', {fsk: node.dataset.level});
          });
        },
      },
    }));
  } else if (showDoiHint) {
    if (!user.doi_at) {
      onsOverlay.create('doiHint').disableBackdrop().open();
    }

    showDoiHint = false;
  } else if (showChangeEmail) {
    onsOverlay.create('changeEmailOverlay').disableBackdrop().open();
    showChangeEmail = false;
  } else {
    triggerConfirmNotification();
  }
};

let confirmNotificationDone = false;

const triggerConfirmNotification = async () => {
  const delaySeconds = 10;

  if (confirmNotificationDone || now() - loginTime < delaySeconds * 1e3) {
    return;
  }

  confirmNotificationDone = true;
  (await new NotificationManager().confirm())?.open(['core', 'confirm-notification']);
};

export {setPopups, triggerPopups};
